import React from 'react'
import BookingViewR from '../Components/BookingViewR'
import SidebarLayout from '../Components/sidebar/SidebarLayout'

const BookingView = () => {
  return (
    <>
      <SidebarLayout>
        <div className="col-md-12">
          <BookingViewR />
        </div>
      </SidebarLayout>
    </>
  )
}

export default BookingView